import React from 'react'
import { Button, message, Form, Input, Tabs, Divider } from 'antd'
import api, { AppUser, ChangePasswordInput } from 'api'
import PasswordForm from './PasswordForm'
import { AppEvent } from 'components/AppEvent'

const TabPane = Tabs.TabPane
interface IState {
	model: AppUser
	changePasswordInput?: ChangePasswordInput
	modifyPsw: boolean
}

export default class extends React.Component {
	state: IState = { model: {}, changePasswordInput: {}, modifyPsw: false }

	async componentDidMount() {
		let model = await api.appuser.getCurrUser()
		let changePasswordInput = { userId: model.id, password: '' }
		this.setState({ model, changePasswordInput })
	}

	onValueChange = (e: any) => {
		let { model } = this.state
		model.email = e.target.value
		this.setState({ model })
	}

	handleSubmit = async (data: any) => {
		let { model } = this.state
		await api.appuser.updateUserInfo(model)
		message.success('保存成功')
		this.setState({ modifyPsw: false })
	}

	ChangePassword = async (model: AppUser, titleName: string) => {
		await AppEvent.openDialog(<PasswordForm model={model} />, {
			title: titleName,
		})
	}

	render() {
		const { model } = this.state
		const onModifyStyle = this.state.modifyPsw ? { display: 'none' } : {}
		return (
			<div
				style={{
					backgroundColor: '#fff',
					padding: '10px 10px',
					width: '100%',
					height: '100%',
					overflow: 'hidden',
				}}
			>
				<div style={{ height: '25px' }} className="antd-pro-pages-account-settings-style-leftMenu"></div>

				<Tabs style={{ height: '100%', fontSize: '30px' }} defaultActiveKey="0">
					<TabPane tab="基本设置" key={`${1}`}>
						<Form layout="vertical">
							<div style={{ width: '800px', paddingLeft: '100px' }}>
								<p style={{ fontSize: '30px' }}>基本设置</p>
								<p style={{ fontSize: '17px' }}>邮箱</p>
								<p>
									<Input
										placeholder="请输入邮箱"
										onChange={this.onValueChange}
										value={model.email}
										required={true}
									/>
								</p>
								<p style={{ fontSize: '17px' }}>登录账号</p>
								<p>
									<Input placeholder="登录账号" value={model.account} disabled={false} />
								</p>
								<p style={{ fontSize: '17px' }}>姓名</p>
								<p>
									<Input placeholder="姓名" value={model.name} disabled={false} />
								</p>
								<br />
								<Button type="primary" onClick={this.handleSubmit} htmlType="submit">
									更新基本信息
								</Button>
							</div>
						</Form>
					</TabPane>

					<TabPane tab="安全设置" key={`${2}`}>
						<div style={{ width: '800px', paddingLeft: '100px' }}>
							<p style={{ fontSize: '30px' }}>安全设置</p>
							<p style={{ fontSize: '17px' }}>账户密码</p>
							<a style={{ float: 'right' }}>
								<Button
									style={onModifyStyle}
									type="primary"
									onClick={() => this.ChangePassword(model, '修改密码')}
									htmlType="submit"
								>
									修改
								</Button>
							</a>
							<p style={{ fontSize: '16px', color: '#ADADAD' }}>当前密码强度 :&nbsp;&nbsp;</p>
							<Divider />
						</div>
					</TabPane>
				</Tabs>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/Home/PersonalInfo.tsx